import { getCurrentRegion } from 'shared/components/RegionSwitcher/regionState';
import { getLocalStorage } from '@nordvpn/teams.core/lib/tools/localStorageService';
import { STORAGE_NAME_AUTH } from 'pages/LoginOld/constants';
import { refreshToken } from './Auth/utils';
import { REGION_HEADER, isRegionAgnosticPath } from './regionHeader';
import { tokensRenewMemo } from './utils/axios';
/**
 * Adds token to authorization header.
 */
export var addAuthHeaderInterceptor = function addAuthHeaderInterceptor(request) {
    var storage = getLocalStorage(STORAGE_NAME_AUTH);
    var intercepted = request;
    if (storage !== null && storage !== void 0 && storage.token) {
        intercepted.headers.Authorization = "Bearer ".concat(storage.token);
    }
    return intercepted;
};
/**
 * Refresh expired token.
 */
export var renewTokenInterceptor = function renewTokenInterceptor(axios) {
    return refreshToken(axios, function (token) {
        return tokensRenewMemo(axios, token);
    });
};
/**
 * Adds the target region to headers. Sent on every region dependent request, regardless of the
 * multi-region feature flag - the backend decides whether to honour it.
 */
export var addRegionHeaderInterceptor = function addRegionHeaderInterceptor(request) {
    var intercepted = request;
    if (isRegionAgnosticPath(request.url))
        return intercepted;
    intercepted.headers[REGION_HEADER] = getCurrentRegion();
    return intercepted;
};
